if (!customElements.get("m-image-layer")) {
  class MImageLayer extends HTMLElement {
    constructor() {
      super();
      this.enableParallax = false;
    }

    connectedCallback() {
      this.enableParallax = this.dataset.enableParallax === "true";
      if (this.enableParallax) {
        this.initElements();
        if (!this.firstImage || !this.secondImage) return;
        MinimogTheme.Motion.inView(this, this.initAnimations.bind(this));
      }
    }

    initElements() {
      this.firstImage = this.querySelector(".m-image-with-text__image-first");
      this.secondImage = this.querySelector(".m-image-with-text__image-second");

      if (!this.firstImage || !this.secondImage) {
        return;
      }
    }

    initAnimations() {
      if (!this.firstImage || !this.secondImage) return;
      this.animateElement(this.secondImage, [`translateY(30%)`, `translateY(0)`]);
      this.animateElement(this.firstImage, [`translateY(-5%)`, `translateY(0)`]);
    }

    animateElement(element, transforms) {
      if (!element) return;
      const animation = MinimogTheme.Motion.animate(element, { transform: transforms }, { easing: "linear" });
      if (!animation || typeof animation.pause !== "function") return;

      MinimogTheme.Motion.scroll(
        animation,
        {
          target: element,
          offset: ["start end", "end start"],
        }
      );
    }
  }

  customElements.define("m-image-layer", MImageLayer);
}
